import React from "react";
import locale from "@bonliva-crm/locale";
import { FilterWithFavouriteProps } from "../utils/filters-record-types";
import { ToggleBtnFilter } from "./_common/toggle-btn-filter";
import { ConsultantContractPayoutType } from "@bonliva-crm/shared";
import { WithTooltip } from "@common";

type Option = { label: React.ReactNode; value: ConsultantContractPayoutType | null };

export type ConsultantPayoutFilterProps = {
  label?: string;
  options?: Option[];
} & FilterWithFavouriteProps;

export const ConsultantPayoutFilter = ({
  label,
  options,
  ...props
}: ConsultantPayoutFilterProps) => {
  const title = label ?? locale.payoutPeriod;

  return (
    <ToggleBtnFilter
      label={title}
      options={[
        {
          label: (
            <WithTooltip title={"Månadsutbetalning"} placement="top">
              <span>{"M"}</span>
            </WithTooltip>
          ),
          value: ConsultantContractPayoutType.Monthly
        },
        {
          label: (
            <WithTooltip title={"Veckoutbetalning"} placement="top">
              <span>{"V"}</span>
            </WithTooltip>
          ),
          value: ConsultantContractPayoutType.Weekly
        }
      ]}
      {...props}
    />
  );
};
